import { isNullOrUndefined } from '@vy/utils';
import { PlanInputFormSchema } from './plan-input-form';

export const RevisePlanInputFormSchema = PlanInputFormSchema.superRefine((data, ctx) => {
  data.usageProducts?.forEach((product, index) => {
    const originalAmount = product._originalCommitmentAmount;
    if (originalAmount && product.commitment?.amount && product.commitment.amount < originalAmount) {
      ctx.addIssue({
        path: ['usageProducts', index, 'commitment', 'amount'],
        message: `Commitment amount cannot be reduced below ${originalAmount}`,
        code: 'custom',
      });
    }

    if (originalAmount && isNullOrUndefined(product.commitment?.amount)) {
      ctx.addIssue({
        path: ['usageProducts', index, 'commitment'],
        message: 'Cannot remove existing commitment',
        code: 'custom',
      });
    }
  });
});
